import { ConfigRepository } from "~~/repositories/ConfigRepository";

export default defineNuxtPlugin(async () => {
	const publicConfig = usePublicConfigState();
	if (publicConfig.value) {
		return;
	}

	const configRepository = new ConfigRepository();
	publicConfig.value = await configRepository.fetchPublicConfig();
});
